module.exports = __webpack_public_path__ + "553572fafe6863fc3461a08e27e002c2.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/covers/cover_16.jpg
 ** module id = 598
 ** module chunks = 0
 **/